// extracted by mini-css-extract-plugin
export default {"impression":"Impression_impression__hDwpN","caption":"Impression_caption__umGLL"};